import { render, staticRenderFns } from "./ImporterMonitor.vue?vue&type=template&id=84d70b54&scoped=true"
import script from "./ImporterMonitor.vue?vue&type=script&lang=js"
export * from "./ImporterMonitor.vue?vue&type=script&lang=js"
import style0 from "./ImporterMonitor.vue?vue&type=style&index=0&id=84d70b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d70b54",
  null
  
)

export default component.exports